/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair2/style.css';
import FormStructure from './thecateredaffair2/form_structure';

export default FormStructure;